import type { SVGProps } from "react";
export function ExclamationCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m8 2.5c-3.03757 0-5.5 2.46243-5.5 5.5 0 3.0376 2.46243 5.5 5.5 5.5 3.0376 0 5.5-2.4624 5.5-5.5 0-3.03757-2.4624-5.5-5.5-5.5zm-6.5 5.5c0-3.58985 2.91015-6.5 6.5-6.5 3.5899 0 6.5 2.91015 6.5 6.5 0 3.5899-2.9101 6.5-6.5 6.5-3.58985 0-6.5-2.9101-6.5-6.5zm6.5-3.16667c.27614 0 .5.22386.5.5v2.66667c0 .27614-.22386.5-.5.5s-.5-.22386-.5-.5v-2.66667c0-.27614.22386-.5.5-.5zm-.5 5.83337c0-.2762.22386-.5.5-.5h.00667c.27614 0 .5.2238.5.5 0 .2761-.22386.5-.5.5h-.00667c-.27614 0-.5-.2239-.5-.5z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
